export default __webpack_public_path__ + "static/media/loader.e163bfa5.mp4";